import { useEffect, useRef } from 'react';
import { registerBackHandler, type BackLevel } from './backStack';

/**
 * Registers `handler` as this layer's back step while `active`. The latest
 * handler is read through a ref, so an inline closure does not re-register
 * (and lose its place in the stack) on every render.
 */
export function useBackHandler(active: boolean, handler: () => void, level: BackLevel): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!active) return;
    return registerBackHandler(level, () => handlerRef.current());
  }, [active, level]);
}

/** Swallows back while `active` — for work that must not be walked away from. */
export function useBackBlocker(active: boolean): void {
  useBackHandler(active, noop, 'blocking');
}

function noop(): void {}
